/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function() {
  // Add custom code below this line
//  var element = document.getElementById("AddressNewForm");
//    element.classList.toggle("hidden");
// var element1 = document.getElementById("EditAddress_{{ address.id }}");
//    element1.classList.toggle("hidden");
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
$(document).on("click","#cart-drawer .drawer__close",function(){
$("#cart-drawer").addClass("is-closing");
$("#cart-drawer").removeClass("is-open");
$("body").css("overflow","auto");
});
$(document).on("click",".navlink.navlink--cart.navlink--cart--icon",function(){
$("#cart-drawer").removeClass("is-closing")
});


/********************************************
 * SINGLE-VARIANT “ADD TO CART” HANDLER
 ********************************************/

// Attach this to your single-variant button: 
//  <button data-single-variant-add="{{ product.id }}">Add to cart</button>

$(document).on("click", "[data-single-variant-add]", function() {
  console.log("Single variant add clicked. Product ID:", $(this).data("single-variant-add"));

  // 1) Find the container .custom-grid_variants-outer
  var $parent = $(this).closest(".custom-grid_variants-outer");
  if (!$parent.length) {
    console.error("No .custom-grid_variants-outer found. Check markup.");
    return;
  }

  // 2) Grab the single variant ID from the hidden <option>
  var $option = $parent.find(".vardata_hiiden_selected select option");
  if (!$option.length) {
    console.error("No <option> found in .vardata_hiiden_selected. Check markup.");
    return;
  }

  var quick_add_var = $option.val(); // e.g. "45865810034912"
  var variantTitle  = $option.data("title"); // e.g. "Default Title"
  console.log("Single variant => Title:", variantTitle, "ID:", quick_add_var);

  if (!quick_add_var) {
    console.error("Variant ID is missing/undefined. Cannot add to cart.");
    return;
  }

  // 3) Do POST /cart/add.js, same success steps as your multi-variant script
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { id: quick_add_var, quantity: 1 },
    dataType: 'json',
    success: function(productid) {
      // console.log("Single variant added successfully:", productid);

      // === Refresh the cart drawer (like your existing code) ===
      $.ajax({
        type: 'GET',
        url: '/',
        dataType: 'html',
        success: function(carthtml) {
          $("#cart-drawer").html($(carthtml).find("#cart-drawer").html());
          $("#cart-drawer").removeClass("is-empty").removeClass("is-closing");
          
          // Fire same custom event if needed
          document.dispatchEvent(
            new CustomEvent('theme:product:added', {
              bubbles: true,
            })
          );
        },
        error: function(xhr, status, error) {
          console.error("Error fetching cart drawer HTML:", error);
        }
      });

      // === Also do /cart.js to get updated item_count, etc. ===
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          document.dispatchEvent(
            new CustomEvent('theme:cart:change', {
              bubbles: true,
              detail: {
                cartCount: cart.item_count,
              },
            })
          );
        },
        error: function(xhr, status, error) {
          console.error("Error fetching cart.js:", error);
        }
      });
    },
    error: function(xhr, status, error) {
      console.error("Error adding single variant to cart:", error, xhr);
    }
  });
});



$(document).on("click", ".custom-grid_variants-outer .radio__buttons input", function(e) {
  var $parent = $(this).closest(".custom-grid_variants-outer");
  $parent.find(".vardata_hiiden_selected select option").removeAttr("selected");
  var text = '';
  $parent.find(".radio__buttons input").each(function() {
    if ($(this).is(":checked")) {
      text += $(this).val() + " / ";
    }
  });
  var newname = text.slice(0, -2).trim();
  var quick_add_var = $parent.find(".vardata_hiiden_selected select option[data-title='" + newname + "']").val();
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: quick_add_var,
      quantity: 1
    },
    dataType: 'json',
    success: function(productid) {
      $.ajax({
    type: 'GET',
    url: '/',
    dataType: 'html',
    success: function(carthtml) {
      $("#cart-drawer").html($(carthtml).find("#cart-drawer").html());
      $("#cart-drawer").removeClass("is-empty");
$("#cart-drawer").removeClass("is-closing");
              document.dispatchEvent(
          new CustomEvent('theme:product:added', {
            bubbles: true,
          })
        );    
    },
    error: function(xhr, status, error) {
      console.error("Error fetching cart: " + error);
    }
  });
            $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {

    document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
    bubbles: true,
    detail: {
    cartCount: cart.item_count,
    },
    })
    );
    },
    error: function(xhr, status, error) {
      console.error("Error fetching cart: " + error);
    }
  });
    },
    error: function(xhr, status, error) {
      console.error("Error adding to cart: " + error);
    }
  });
});
    // $(".earn-wrapper").click(function(){
    //         $('html, body').scrollTop($(".yotpo-widget-campaign-widget .campaigns-wrapper").offset().top - 100);
    //      });
    // $(".reedem-wrapper ").click(function(){
    //         $('html, body').scrollTop($(".yotpo-coupons-redemption-widget-container.yotpo-one-time-purchase-redemption-mode").offset().top - 100);
    //      });


$(document).ready(function() {
    $('a[href^="#"]:not(.account-sidebar a)').on('click', function(event) {
        event.preventDefault(); // Prevent default jump

        var target = $(this.getAttribute('href')); // Get the target element

        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 800); // Adjust speed (800ms)
        }
    });
});


/** VIP Tiers JS ****/
/**
 * @class CustomLoyaltyPage
 * @description A class to customize the loyalty page based on data loaded from a Shopify app.
 */
class CustomLoyaltyPage {

    
    
    
    /**
     * @constructor
     * @param {object} config - The _ALConfig object containing loyalty page data.
     */
    constructor(config) {

        this.authenticatedSelector = '.authenticated';
        this.unauthenticatedSelector = '.unauthenticated';
        this.customerNameSelector = '.customer-name';
        this.customerPointsSelector = '.customer-points';
        this.customerLevelSelector = '.customer-level';
        this.expirationDateSelector = '.customer-points-expiration'
        this.remainingPointsSelector = '.remaining-points'
        this.spentAmountSelector = '.spent-amount';
        this.nextLevelSelector = '.next-level'
        this.nextLevelThresholdSelector = '.next-level-threshold'
        this.progressBarSelector = '.loyalty-progress-bar'
        this.benefitsSelector = '.vip-benefits'

        

        this.config = config;
        this.customerLoyalty = config.customerLoyalty || {};
        this.customerVIPTier = this.customerLoyalty.currentVipTier ?? "ORIGINE";
        this.customerSpentAmount = this.customerLoyalty.spentAmount || 0;
        this.customerName = config.customerName;
         this.pointsExpirationSetting = config.pointsExpirationSetting;
        this.lastActivityDate = this.customerLoyalty.lastActivityDate;

        // ===================================================================
        // ======================= FOR TESTING ONLY ==========================
        // ===================================================================
        //  To test a different VIP section, uncomment and change these lines.
        //  This will override the real customer data for this page load.
        // ===================================================================

        // --- Example: Test the 'PRESTIGE' tier ---
        // this.customerVIPTier = "PRESTIGE"; // Available Tiers: "ORIGINE", "INITIÉE", "PRESTIGE", "CERCLE INTÉRIEUR"
        // this.customerSpentAmount = 2500; // A realistic amount for the PRESTIGE tier (milestone is 2000)

        // --- Example: Test the 'INITIÉE' tier ---
         // this.customerVIPTier = "INITIÉE";
         // this.customerSpentAmount = 850; // Milestone is 750

        // --- Example: Test the 'CERCLE INTÉRIEUR' tier ---
         //this.customerVIPTier = "CERCLE INTÉRIEUR";
         //this.customerSpentAmount = 5600; // Milestone is 5000

        // ===================================================================
        // ======================== END OF TEST BLOCK ========================
        // ===================================================================

        this.handleAuthenticatedSections()
        const nextLevelData= this.getNextLevel();
        const pointsExpirationDate = this.getPointsExpirationDate();
        if(nextLevelData){
            this.nextTier = nextLevelData.nextTier;
            this.nextTierMilestone = this.nextTier.milestone;
            this.amountNeeded = nextLevelData.amountNeeded;
        }else{
          this.highestTierReached = true;
        }
        if(pointsExpirationDate){
            this.pointsExpirationDate = pointsExpirationDate;
        }
        this.handleProgressCalculator()
        this.handleTableActiveTierSelection()
        this.replacePlaceholders()
        this.handleInteractiveBenefits()
        this.handlePopupCloseButtonInjection();

        // Recalculate table cell heights
        if(equalizeVipTierHeights){
            equalizeVipTierHeights()
        }
    }

    getNextLevel(){
         if (!this.isCustomerLoggedIn() || !this.config.vipTiers || !this.customerVIPTier) {
            return null;
        }

          const sortedTiers = [...this.config.vipTiers].sort((a, b) => a.milestone - b.milestone);
          const currentTierIndex = sortedTiers.findIndex(tier => tier.name === this.customerVIPTier);

          // If the current tier isn't found or is the highest tier, there's no next level.
        if (currentTierIndex === -1 || currentTierIndex === sortedTiers.length - 1) {
            return null;
        }

        const nextTier = sortedTiers[currentTierIndex + 1];
        const amountNeeded = nextTier.milestone - this.customerSpentAmount;
        
        return { nextTier, amountNeeded };
        
    }

     getPointsExpirationDate() {
        if (!this.isCustomerLoggedIn() || !this.lastActivityDate || !this.pointsExpirationSetting) {
            return null;
        }

        const { expirationInterval, expirationIntervalType } = this.pointsExpirationSetting;
        const lastActivity = new Date(this.lastActivityDate);

        // Check for invalid date
        if (isNaN(lastActivity.getTime())) {
            return null;
        }

        switch (expirationIntervalType) {
            case 'YEAR':
                lastActivity.setFullYear(lastActivity.getFullYear() + expirationInterval);
                break;
            case 'MONTH':
                lastActivity.setMonth(lastActivity.getMonth() + expirationInterval);
                break;
            case 'DAY':
                lastActivity.setDate(lastActivity.getDate() + expirationInterval);
                break;
            default:
                // If the interval type is unknown, we cannot calculate the date.
                return null;
        }

        return lastActivity;
    }

    toggleHistoryModal(){
    const loyaltyPageHistorySection = document.querySelector('#loyaltyPageHistorySection');
    if(!document.querySelector('.template-name-new-loyalty') || !loyaltyPageHistorySection) return;
    document.querySelector('body').classList.toggle('showHistory');
  }

     handleInteractiveBenefits(){
        if(!this.isCustomerLoggedIn()){
            return null;
        }
        
        const benefitsElement = document.querySelector(this.benefitsSelector);
        const firstGridItem = benefitsElement.querySelector('.grid-item')
        // User account already created, so replace overlay text with "Action Completee"
        firstGridItem.querySelector('.column-overlay__hover-content').innerHTML = `
            <p>
                <span style="color: green; margin-left: 8px;">&#10003;</span>
                <strong>Action Completed</strong>
            </p>
        `;

        const isAnniversaryProvided = this.customerLoyalty.dob;
        const anniversaryGridItem = benefitsElement.querySelector('.grid-item:nth-child(2)')
        if(isAnniversaryProvided){
            anniversaryGridItem.querySelector('.column-overlay__hover-content').innerHTML = `
                <p>
                    <span style="color: green; margin-left: 8px;">&#10003;</span>
                    <strong>Votre anniversaire est inscrit à votre compte.</strong>
                </p>
            `;
        }else{
            anniversaryGridItem.querySelector('.column-overlay__hover-content').innerHTML = `<p><strong>Ajoutez votre anniversaire à votre compte.</strong></p>`

            anniversaryGridItem.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                window.scrollTo({
                    top: document.querySelector('#loyaltyPageVipSection').offsetTop,
                    behavior: 'smooth'
                })
            })
        }


        const hasUserPurchased = this.customerLoyalty.spentAmount > 0;
        const purchaseGridItem = benefitsElement.querySelector('.grid-item:nth-child(3)')
        if(hasUserPurchased){
            purchaseGridItem.querySelector('.column-overlay__hover-content').innerHTML = `
                <p>
                    <span style="color: green; margin-left: 8px;">&#10003;</span>
                    <strong>Vous bénéficiez déjà du multiplicateur de 1,2x.</strong>
                </p>
            `;
        }else{
            purchaseGridItem.querySelector('.column-overlay__hover-content').innerHTML = `<p><strong>Obtenez 1,2x Points lorsque vous effectuez votre premier achat.</strong></p>`
        }


  

        const heroButtons = document.querySelectorAll('.pointSummary .hero__button a')
        heroButtons.forEach(button=>{
            button.addEventListener('click', (e)=>{
                if(button.href == '#!'){
                    e.preventDefault();
                    e.stopPropagation();
                }
                if(button.classList.contains('btn--solid')){
                    window.scrollTo({
                        top: document.querySelector('.pointsBreakdown').offsetTop,
                        behavior: 'smooth'
                    })
                }else{
                   // Show the points history popup:
                   this.toggleHistoryModal();
                }
                
              
            })
        })

        
    }

    /**
     * @method isCustomerLoggedIn
     * @description Checks if the customer is logged in based on the presence of a customer ID in the config.
     * @returns {boolean} - True if the customer is logged in, false otherwise.
     */
    isCustomerLoggedIn() {
        return !!this.config.customerId;
    }

    /**
     * @method handleAuthenticatedSections
     * @description Shows or hides sections of the page based on the user's authentication status.
     */
    handleAuthenticatedSections() {
        const isLoggedIn = this.isCustomerLoggedIn();
        const authenticatedElements = document.querySelectorAll(this.authenticatedSelector);
        const unauthenticatedElements = document.querySelectorAll(this.unauthenticatedSelector);

        if (isLoggedIn) {
            authenticatedElements.forEach(el => el.style.display = 'block');
            unauthenticatedElements.forEach(el => el.style.display = 'none');
        } else {
            authenticatedElements.forEach(el => el.style.display = 'none');
            unauthenticatedElements.forEach(el => el.style.display = 'block');
        }
    }

    handlePopupCloseButtonInjection(){
       setTimeout(() => {
        // Find history modal and inject close button:
        const loyaltyPageHistorySection = document.querySelector('#loyaltyPageHistorySection');
        if(!document.querySelector('.template-name-new-loyalty') || !loyaltyPageHistorySection) return;
        // Find history modal and inject close button:
        const closeButton = document.createElement('div');
        closeButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M20 20L4 4.00003M20 4L4.00002 20" stroke="black" stroke-width="2" stroke-linecap="round"/>
</svg>`;
        closeButton.classList.add('closeModal');

        loyaltyPageHistorySection.appendChild(closeButton)
        loyaltyPageHistorySection.querySelector('.closeModal').addEventListener('click', e=>{
          this.toggleHistoryModal();
        })
       }, 2500);
    }



    bulkReplacer(classSelector, value){
        document.querySelectorAll(classSelector).forEach(item=>item.innerText = value)
    }

    handleProgressCalculator(){
        if (!this.isCustomerLoggedIn() || (!this.nextTierMilestone && !this.highestTierReached) || !this.customerSpentAmount) {
            return null;
        }

        const percentage = this.highestTierReached ? 100 :( this.customerSpentAmount / this.nextTierMilestone) * 100;
        this.progressPercentage = percentage;

        document.querySelectorAll(this.progressBarSelector).forEach(item=>item.value = percentage)
    }


    handleTableActiveTierSelection(){
        if (!this.isCustomerLoggedIn() || !this.customerVIPTier) {
            return null;
        }

        const activeTableCol = document.querySelector(`.vip-tiers-grid-column[data-tier="${this.customerVIPTier}"]`)

        activeTableCol.classList.add('vip-tiers-grid-column-active')
    }

    handleHighestTierContent(){
        document.querySelector('.customer-current-experience .spendMore').classList.add('hidden');
        const para = document.createElement('p');
        para.innerText = 'Félicitations ! Vous avez atteint notre plus haut niveau. Merci pour votre incroyable fidélité !';
        document.querySelector('.customer-current-experience .spendMore').insertAdjacentElement('afterend', para)

        document.querySelectorAll('.loyalty-progress-container .next-level,.loyalty-progress-container .value-right').forEach(it=>it.classList.add('hidden'));
    }


    replacePlaceholders(){
        this.bulkReplacer(this.customerPointsSelector, `${this.config.customerLoyalty.availablePoints} Point${this.config.customerLoyalty.availablePoints > 0 ? 's' : ''}`)
        this.bulkReplacer(this.customerNameSelector, this.customerName);
        this.bulkReplacer(this.customerLevelSelector, this.customerVIPTier)
        this.bulkReplacer(this.expirationDateSelector, this.pointsExpirationDate)
        this.bulkReplacer(this.remainingPointsSelector, this.amountNeeded)
        this.bulkReplacer(this.spentAmountSelector, this.customerSpentAmount)
        if(this.nextTier){
          this.bulkReplacer(this.nextLevelSelector, this.nextTier.name)
          this.bulkReplacer(this.nextLevelThresholdSelector, this.nextTierMilestone)
        }else if(this.highestTierReached){
          this.handleHighestTierContent()
        }

        this.bulkReplacer(this.progressBarSelector, this.progressPercentage)
    }
}

function equalizeVipTierHeights() {
    const rows = {};

    // Group children by their row index
    document.querySelectorAll('.vip-tiers-grid-column').forEach((col) => {
        Array.from(col.children).forEach((row, index) => {
            (rows[index] ??= []).push(row);
        });
    });

    // For each row group, equalize heights
    Object.values(rows).forEach((rowGroup) => {
        // Reset heights in case function is called again
        rowGroup.forEach(el => el.style.height = '');

        const maxHeight = Math.max(...rowGroup.map(el => el.offsetHeight));

        rowGroup.forEach(el => {
            el.style.height = `${maxHeight}px`;
        });
    });
}

if(document.querySelector('.vip-tiers-section')){
  // Run once DOM is loaded
  document.addEventListener("DOMContentLoaded", ()=>{
    equalizeVipTierHeights();
    
    new CustomLoyaltyPage(_ALConfig)
  });

  // Optional: run again on window resize for responsiveness
  window.addEventListener("resize", equalizeVipTierHeights);
}






/** VIP Tiers JS End*/